var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.css)?_c('span',{staticClass:"cms-custom-css"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }